import type { GoldenSetName, GoldenSetOutcome } from './api.ts'

/** What each set answers, in the words the dialog and the toast both use. */
export const GOLDEN_SET_LABEL: Readonly<Record<GoldenSetName, string>> = {
  reader: 'caso de leitura',
  resolution: 'caso de comparação',
}

/**
 * What to tell somebody who has just added a conferência to the golden set.
 *
 * Per set, because the two can differ in the same request -- one created, the
 * other already there -- and a single "adicionado" hides exactly the half that
 * did not happen. That was the complaint this dialog exists to answer: the
 * button wrote both sets and said neither, so the comparison case looked like
 * something it had never done.
 */
export function goldenSetSummary(outcomes: Readonly<Record<GoldenSetName, GoldenSetOutcome>>): {
  readonly message: string
  readonly detail: string | undefined
} {
  const asked = (['reader', 'resolution'] as const).filter((set) => outcomes[set] !== 'skipped')
  const created = asked.filter((set) => outcomes[set] === 'created')
  const existing = asked.filter((set) => outcomes[set] === 'exists')

  const list = (sets: readonly GoldenSetName[]) =>
    sets.map((set) => GOLDEN_SET_LABEL[set]).join(' e ')

  if (created.length === 0) {
    return {
      message: `Esta conferência já está no golden set: ${list(existing)}.`,
      detail: undefined,
    }
  }

  return {
    message: `Rascunho criado no golden set: ${list(created)}.`,
    // Named rather than silent: somebody who ticked both and got one needs to
    // know the other was left alone, not overwritten.
    detail:
      existing.length === 0 ? undefined : `O ${list(existing)} já existia e não foi alterado.`,
  }
}
